var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { BaseApp } from "../base-app";
import { GenesisRouterConstants } from "../../../configuration/router.constants";
import { PLATFORM } from "aurelia-pal";
import { autoinject } from "aurelia-dependency-injection";
import { DialogClientService } from "../../../services/basics/dialog-client.service";
import { EventAggregator } from "aurelia-event-aggregator";
import { Router } from "aurelia-router";
import { SignalClientService } from "../../../services/basics/signal-client.service";
import { CacheClient } from "../../../services/basics/client-caching.service";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../services/lookups/lookup-client.service";
import { TokenClient } from "../../../services/authentication/token-client.service";
import { NavigationClientService } from "../../../services/modules/navigation-client.service";
require('../../../styles/anonymous/core-anonymous.scss');
var Anonymous = /** @class */ (function (_super) {
    __extends(Anonymous, _super);
    function Anonymous(router, tokenClient, eventAggregator, dialogClient, signalClientService, cacheClient, i18n, lookupsService, navigationClientService) {
        var _this = _super.call(this, router, tokenClient, dialogClient, eventAggregator, signalClientService, cacheClient, navigationClientService, lookupsService) || this;
        _this.i18n = i18n;
        return _this;
    }
    Anonymous.prototype.onReconnected = function () {
    };
    Anonymous.prototype.activate = function () {
        return _super.prototype.activate.call(this);
    };
    Anonymous.prototype.attached = function () {
        _super.prototype.attached.call(this);
    };
    Anonymous.prototype.detached = function () {
        _super.prototype.detached.call(this);
    };
    Anonymous.prototype.getRoutes = function () {
        return [{
                route: ["", "login"],
                name: GenesisRouterConstants.RouteNames.Login,
                moduleId: PLATFORM.moduleName("../../pages/authentication/login"),
                nav: true,
                title: this.i18n.tr("login")
            }, {
                route: ["register"],
                name: GenesisRouterConstants.RouteNames.Register,
                moduleId: PLATFORM.moduleName("../../pages/authentication/register"),
                nav: true,
                title: this.i18n.tr("register")
            },
            {
                route: "forgotPassword",
                name: GenesisRouterConstants.RouteNames.ForgotPassword,
                moduleId: PLATFORM.moduleName("../../pages/authentication/forgot-password"),
                auth: false,
                title: this.i18n.tr('forgot-password-text')
            }, {
                moduleId: PLATFORM.moduleName("../../pages/authentication/change-password"),
                name: GenesisRouterConstants.RouteNames.ChangePassword,
                route: ["change-password"],
                title: this.i18n.tr("change-password-text"),
                auth: false
            },
            {
                moduleId: PLATFORM.moduleName("../../pages/authentication/reset-password"),
                name: GenesisRouterConstants.RouteNames.ResetPassword,
                route: ["ResetPassword"],
                title: this.i18n.tr("reset-password-text"),
                auth: false
            }];
    };
    Anonymous = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Router, TokenClient, EventAggregator, DialogClientService, SignalClientService,
            CacheClient, I18N, LookupClientService, NavigationClientService])
    ], Anonymous);
    return Anonymous;
}(BaseApp));
export { Anonymous };
